import { render, staticRenderFns } from "./automatismo.vue?vue&type=template&id=7ad26666&scoped=true"
import script from "./automatismo.vue?vue&type=script&lang=ts"
export * from "./automatismo.vue?vue&type=script&lang=ts"
import style0 from "./automatismo.vue?vue&type=style&index=0&id=7ad26666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad26666",
  null
  
)

export default component.exports